// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  font-family: \"Roboto\", sans-serif !important;\n  margin: 0;\n  padding: 0;\n  /* font-family: sans-serif; */\n}\n\n/* to remove scrollbar in windows */\nhtml {\n  margin: 0;\n  padding: 0;\n  overflow: visible;\n  overflow-x: hidden;\n  /* remove firefox scrollbar on html*/\n  scrollbar-width: none;\n  /* background-color: #f0f0f0; */\n}\n\n* {\n  scrollbar-width: none;\n}\n\n/* to remove scrollbar in windows */\n\n.Select-menu-outer {\n  z-index: 1000 !important;\n}\n", ""]);
// Exports
module.exports = exports;
